const clickEvents = {
  rotationPosterWidget: {
    widgetName: 'RotationPoster'
  },
  advertisingSpaceWidget: {
    widgetName: 'AdvertisingSpace'
  },
  shortcutWidget: {
    widgetName: 'Shortcut'
  },
  switchLabelWidget: {
    widgetName: 'SwitchLabel'
  },
  asinShowcaseWidget: {
    widgetName: 'AsinShowcase'
  },
  mapAreaWidget: {
    widgetName: 'MapArea'
  },
  couponWidgetWidget: {
    widgetName: 'CouponWidget'
  },
  introductionWidget: {
    widgetName: 'Introduction'
  },
  popupWidgetWidget: {
    widgetName: 'PopupWidget'
  },
  bestsellerWidget: {
    widgetName: 'Bestseller'
  },
  storeAnnouncementWidget: {
    widgetName: 'StoreAnnouncement'
  },
  dealWidgetWidget: {
    widgetName: 'DealWidget'
  },
  claimCouponButton: {
    widgetName: 'claimCoupon'
  }
};

const loadingEvents = {
  gatewayPage: {
    pageName: 'gatewayPage',
    eventName: 'ATF'
  },
  landingPage: {
    pageName: 'landingPage',
    eventName: 'ATF'
  }
};

export default {
  clickEvents,
  loadingEvents
};
